import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface HelpProviderProps {
  children: ReactNode;
}

interface HelpContextType {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const HelpContext = createContext<HelpContextType | null>(null);

export const HelpProvider = ({ children }: HelpProviderProps) => {
  const [open, setOpen] = useState(false);

  return (
    <HelpContext.Provider value={{ open, setOpen }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelpContext must be used within a HelpContextProvider');
  }
  return context;
};
